<script>
    import Artists from './Artists.svelte';
    import Tracks from './Tracks.svelte';
    let activeTab = 'artists';
    function selectTab(tab) {
        activeTab = tab;
    }

</script>

<div>
    <section id="tabs-container">
        <div class="tab {activeTab==='artists' ? 'active': '' }" on:click={() => selectTab('artists')}>Artists</div>
        <div class="tab {activeTab==='pending' ? 'active': '' }" on:click={() => selectTab('pending')}>Pending</div>
        <div class="tab {activeTab==='active' ? 'active': '' }" on:click={() => selectTab('active')}>Active</div>
    </section>
    <hr/>
    {#if activeTab === 'artists'}
        <Artists />
    {:else if activeTab === 'pending'}
        <Tracks status="pending" />
    {:else if activeTab === 'active'}
        <Tracks status="active" />
    {/if}
</div>

<style>
    #tabs-container {
        display: flex;
        justify-content: space-evenly;
    }
    .tab {
        padding: 7px;
        font-size: 1.5rem;
        cursor: pointer;
    }
    .tab.active {
        background-color: red;
    }
</style>
